import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { MainService} from './main.service';

@Injectable()
export class ProtocolCommandService {

  constructor(public http: Http, public mainService: MainService) { }

  findAll() {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"protocolCommand")
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  findByProtocol(idProtocol:number) {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"protocolCommand/findByProtocol/"+idProtocol)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  create(protocolCommand:any){
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.mainService.server_url+"protocolCommand",protocolCommand)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  edit(protocolCommand:any){
    let promise = new Promise((resolve, reject) => {
      this.http.put(this.mainService.server_url+"protocolCommand/id;type="+protocolCommand.type+";idProtocol="+protocolCommand.idProtocol,protocolCommand)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  remove(idProtocol:number,type:String){
    let promise = new Promise((resolve, reject) => {
      this.http.delete(this.mainService.server_url+"protocolCommand/id;type="+type+";idProtocol="+idProtocol)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/protocol-command.service.ts